"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MPShop
 * API documentation
 *
 * The version of the OpenAPI document: 0.0.1-alpha.58
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseGetBasketAddOnsToJSON = exports.ResponseGetBasketAddOnsFromJSONTyped = exports.ResponseGetBasketAddOnsFromJSON = exports.instanceOfResponseGetBasketAddOns = void 0;
var MultiProductBasketItem_1 = require("./MultiProductBasketItem");
/**
 * Check if a given object implements the ResponseGetBasketAddOns interface.
 */
function instanceOfResponseGetBasketAddOns(value) {
    var isInstance = true;
    isInstance = isInstance && "basketId" in value;
    isInstance = isInstance && "basketAddOns" in value;
    return isInstance;
}
exports.instanceOfResponseGetBasketAddOns = instanceOfResponseGetBasketAddOns;
function ResponseGetBasketAddOnsFromJSON(json) {
    return ResponseGetBasketAddOnsFromJSONTyped(json, false);
}
exports.ResponseGetBasketAddOnsFromJSON = ResponseGetBasketAddOnsFromJSON;
function ResponseGetBasketAddOnsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'basketId': json['basketId'],
        'basketAddOns': (json['basketAddOns'].map(MultiProductBasketItem_1.MultiProductBasketItemFromJSON)),
    };
}
exports.ResponseGetBasketAddOnsFromJSONTyped = ResponseGetBasketAddOnsFromJSONTyped;
function ResponseGetBasketAddOnsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'basketId': value.basketId,
        'basketAddOns': (value.basketAddOns.map(MultiProductBasketItem_1.MultiProductBasketItemToJSON)),
    };
}
exports.ResponseGetBasketAddOnsToJSON = ResponseGetBasketAddOnsToJSON;
